import { Carousel } from "@mantine/carousel"
import {
  AttachmentControllerRoute,
  useDefaultAttachmentsApiForControllerRoute,
} from "../../../attachment-api"
import { SimpleAttachment } from "@/orval/gen/model"
import { FilePreview } from "@components/FilePreview"

export interface AttachmentCarouselProps {
  attachments: SimpleAttachment[]
  containerId: number
  controllerRoute: AttachmentControllerRoute
}

export function AttachmentCarousel({
  attachments,
  containerId,
  controllerRoute,
}: AttachmentCarouselProps) {
  const attachmentApi =
    useDefaultAttachmentsApiForControllerRoute(controllerRoute)
  const slides = React.useMemo(
    () =>
      attachments.map((a) => (
        <Carousel.Slide key={a.attachmentId}>
          <FilePreview
            h={"100%"}
            src={attachmentApi.getFileUrl(a.attachmentId, containerId)}
            fileName={a.fileName}
          />
        </Carousel.Slide>
      )),
    [attachmentApi, attachments, containerId]
  )

  return (
    <Carousel
      type="container"
      withControls={attachments.length > 1}
      withIndicators={attachments.length > 1}
    >
      {slides}
    </Carousel>
  )
}
